<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop" >
            <div class="banner_title"> <span class="color3">Card Payouts:</span> Swift and Simple Transactions</div>
            <div class="banner_tips mt-40 fw-300">Effortlessly settle payments to suppliers, wallet holders, or creators with Minglepay's fast and reliable card payout solutions.</div>
         </div>
       </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap ">
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_col_center">
                    <div class="page_title w-100p text-l">
                        <div class="title_name color2 text-l">Streamlined B2C Payouts with Minglepay</div>
                        <div class="title_tag color6 fs-14">Simplify mass payouts to individuals with Minglepay's advanced technology. Pay suppliers, marketplace users, or creators quickly and efficiently.</div>
                    </div>
                    <div class="item_inner flex pt-50 flex_sb">
                        <div class="group_half text-l  w-48p" >
                        <div class="half_container flex_col_start " >
                            <div class="half_icon w-48px h-48px mb-10">
                            <img src="../../assets/image/tb12.png" alt="" class="">
                            </div>
                            <div class="half_title color2">Industry Insight</div>
                            <div class="half_text color6 mt-10 fs-14 fw-300">We partner with merchants and card acquirers to address the unique challenges of B2C and C2B cash flows.</div>
                        </div>   
                        </div>
                        <div class="group_half text-l w-48p">
                        <div class="half_container flex_col_start " >
                            <div class="half_icon w-48px h-48px mb-10">
                            <img src="../../assets/image/tb13.png" alt="" class="">
                            </div>
                            <div class="half_title color2 ">Expert Solutions</div>
                            <div class="half_text color6 mt-10 fs-14 fw-300">Leverage Minglepay's deep expertise in global card payments to deliver tailored payout solutions for your business.</div>
                            </div>   
                        </div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12" >
                  <div class="w-100p  p-r h-100p pb-100">
                    <div class="bg_5"></div>
                    <img src="../../assets/image/t11.png" alt="" class="po_img">

                  </div>
                </div>
              </div>
            
             
       
          </div>
        </div>
      </div>
    </div>
    
    <div class="container page_top bg_3">
        <div class="page_width">
          <div class="page_title pt-50">
            <div class="title_name ">Global Reach, Local Precision</div>
            <div class="title_tag ">Operate confidently worldwide with Minglepay's extensive geographic coverage and support for local payment preferences.</div>
          </div>
          <div class="mt-100 p-r">
            <img src="../../assets/image/dt2.png" alt="">
            <div class="country fs-10 p-a al-13 at-10 flex_center color1 fw-400 hidden-sm-and-down"><img src="../../assets/image/gq1.png" alt="" class="mr-4 h-10px"><div>CA</div></div>
            <div class="country fs-10 p-a al-43 at-10 flex_center color1 fw-400 hidden-sm-and-down"><img src="../../assets/image/gq2.png" alt="" class="mr-4 h-10px">GB</div>
            <div class="country fs-10 p-a al-49 at-15 flex_center color1 fw-400 hidden-sm-and-down"><img src="../../assets/image/gq3.png" alt="" class="mr-4 h-10px">EU</div>
            <div class="country fs-10 p-a al-16 at-30 flex_center color1 fw-400 hidden-sm-and-down"><img src="../../assets/image/gq4.png" alt="" class="mr-4 h-10px">MX</div>
            <div class="country fs-10 p-a al-72 at-21 flex_center color1 fw-400 hidden-sm-and-down"><img src="../../assets/image/gq5.png" alt="" class="mr-4 h-10px">CN</div>
            <div class="country fs-10 p-a al-83 at-22 flex_center color1 fw-400 hidden-sm-and-down"><img src="../../assets/image/gq6.png" alt="" class="mr-4 h-10px">JP</div>
            <div class="country fs-10 p-a al-80 at-52 flex_center color1 fw-400 hidden-sm-and-down"><img src="../../assets/image/gq7.png" alt="" class="mr-4 h-10px">AU</div>
            <div class="country fs-10 p-a al-29 at-47 flex_center color1 fw-400 hidden-sm-and-down">+ 14</div>
            <div class="country fs-10 p-a al-51 at-38 flex_center color1 fw-400 hidden-sm-and-down">55 +</div>
            <div class="fs-50 color1">55+ Countries Supported</div>
            <div class="fs-16 color1 fw-400 mt-20">High approval rates in regions like North America, Europe, Asia, and more.</div>
          </div>
        </div>
        <div class="custom-scroll mt-50 mb-80">
            <div class="scroll-content">
                <div class="country fs-10 flex_center color1 fw-400" v-for="(item,index) in counrtyList" :key="index"><img :src="item.icon" alt="" class="mr-4 h-10px ">{{ item.name }}</div>
                <div class="country fs-10 flex_center color1 fw-400" v-for="(item,index) in counrtyList" :key="index+22"><img :src="item.icon" alt="" class="mr-4 h-10px ">{{ item.name }}</div>
            </div>
        </div>
         <div class="fs-50 color1">100+ Currencies</div>
         <div class="fs-16 color1 fw-400 mt-20">Accept payments in global currencies to expand your market.</div>
         <div class="custom-scroll mt-50 pb-80">
           <div class="rescroll-content">
                <div class="zf_tab " v-for="(item,index) in zfList" :key="index"><img :src="item.icon" alt="" class="w-50px"></div>
                <div class="zf_tab " v-for="(item,index) in zfList" :key="index+8"><img :src="item.icon" alt="" class="w-50px "></div>
                <div class="zf_tab " v-for="(item,index) in zfList" :key="index+16"><img :src="item.icon" alt="" class="w-50px "></div>
                <div class="zf_tab " v-for="(item,index) in zfList" :key="index+24"><img :src="item.icon" alt="" class="w-50px "></div>
            </div>
        </div>
   
    </div>

    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap ">
                <div class="grid_md_6 grid_xs_12 grid_sm_12">
                    <div class="page_title w-100p text-l">
                        <div class="title_name color2 text-l">Instant Funds Delivery</div>
                        <div class="title_tag color6 fs-14">Experience real-time payouts with Minglepay's global and localized card payment routes.</div>
                    </div>
                    <div class="item_inner flex pt-50 flex_sb">
                        <div class="group_half text-l  w-48p" >
                        <div class="half_container flex_col_start " >
                            <div class="half_icon w-48px h-48px mb-10">
                            <img src="../../assets/image/tb14.png" alt="" class="">
                            </div>
                            <div class="half_title color2">Lightning-Fast Transfers</div>
                            <div class="half_text color6 mt-10 fs-14 fw-300">Deliver funds to payees instantly with AI-driven routing.</div>
                        </div>   
                        </div>
                        <div class="group_half text-l w-48p">
                        <div class="half_container flex_col_start " >
                            <div class="half_icon w-48px h-48px mb-10">
                            <img src="../../assets/image/tb15.png" alt="" class="">
                            </div>
                            <div class="half_title color2">Streamlined Process</div>
                            <div class="half_text color6 mt-10 fs-14 fw-300">Simplified settlement ensures quick and hassle-free payouts.</div>
                            </div>   
                        </div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t12.png" alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color2">Pay Out Using Your Pay-In Balance</div>
            <div class="title_tag color6">Maximize efficiency by using your existing pay-in balance for payouts, reducing costs and cash flow gaps.</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-primary p-20 h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb16.png" alt="" class="">
                        </div>
                        <div class="half_title color2">Cost-Effective</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Eliminate extra bank transfers by leveraging available funds.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-primary p-20 h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb17.png" alt="" class="">
                        </div>
                        <div class="half_title color2">Balance Netting</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Maintain healthy cash flow with seamless fund transfers.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-primary p-20 h-100p" >
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb18.png" alt="" class="">
                        </div>
                        <div class="half_title color2">Instant Availability</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Access and distribute funds without delays.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color2">Powerful Features for Your Business</div>
            <div class="title_tag color6">Unlock a suite of tools designed to simplify and enhance your payment operations.</div>
          </div>
          <div class="cate_container">
              <div class=" grid">
                <div class="grid_md_6 grid_xs_12 grid_sm_12 py-50 pl-50 grid_sp_item">
                    <div class="bg_4 p-50 h-100p">
                       <div class="page_title w-100p text-l">
                           <div class="title_name color1 text-l">Powerful Features for Your Business</div>
                       </div>
                       <div class="flex pt-20">
                        <img src="../../assets/image/g.png" alt="" class="w-30px mr-20">
                        <span class="color1 fs-14 text-l">90%+ Approval Rates: Secure, reliable gateway ensures successful transactions.</span>
                       </div>
                       <div class="flex pt-20">
                        <img src="../../assets/image/g.png" alt="" class="w-30px mr-20">
                        <span class="color1 fs-14 text-l">Universal Platform Support: Seamlessly integrates with all major tech platforms.</span>
                       </div>
                       <div class="flex pt-20">
                        <img src="../../assets/image/g.png" alt="" class="w-30px mr-20">
                        <span class="color1 fs-14 text-l">Easy API Integration: Manage keys and configurations effortlessly.</span>
                       </div>
                       <div class="flex pt-20">
                        <img src="../../assets/image/g.png" alt="" class="w-30px mr-20">
                        <span class="color1 fs-14 text-l">Comprehensive Dashboard: Monitor, manage, and analyze transactions in real time with Minglepay Hub.</span>
                       </div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t9.png" alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color2">Automated Payout Validation</div>
            <div class="title_tag color6">Minglepay's automated review and validation process ensures fast, accurate, and secure payouts.</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-primary p-20 h-100p bg_9">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb19.png" alt="" class="">
                        </div>
                        <div class="half_title color2">Accurate</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Minimizes errors with automated checks.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-primary p-20 h-100p bg_9">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb20.png" alt="" class="">
                        </div>
                        <div class="half_title color2">Efficient</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Speeds up processing to eliminate delays.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-primary p-20 h-100p bg_9" >
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb21.png" alt="" class="">
                        </div>
                        <div class="half_title color2">Secure</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Verifies critical details to protect merchants and payees.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>

   

    <div class="container"> 
      <div class="" >
        <div class="page_width" >
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                    <div class="page_title ">
                        <div class="title_name color2 text-l">Why Choose Minglepay for Payouts?</div>
                        <div class="title_tag color6 text-l">Transform your payout process with Minglepay's cutting-edge technology, global reach, and cost-efficient solutions. Simplify settlements, enhance cash flow, and deliver funds instantly with confidence.</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t13.png" alt="">
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>

import ca from '../../assets/image/gq1.png'
import gb from '../../assets/image/gq2.png'
import eu from '../../assets/image/gq3.png'
import mx from '../../assets/image/gq4.png'
import cn from '../../assets/image/gq5.png'
import jp from '../../assets/image/gq6.png'
import au from '../../assets/image/gq7.png'
import pl from '../../assets/image/gq8.png'
import nl from '../../assets/image/gq9.png'
import be from '../../assets/image/gq10.png'
import dk from '../../assets/image/gq11.png'
import ie from '../../assets/image/gq12.png'
import cz from '../../assets/image/gq13.png'
import ro from '../../assets/image/gq14.png'
import hu from '../../assets/image/gq15.png'
import bg from '../../assets/image/gq16.png'
import es from '../../assets/image/gq17.png'
import pt from '../../assets/image/gq18.png'
import fi from '../../assets/image/gq19.png'
import se from '../../assets/image/gq20.png'
import lv from '../../assets/image/gq21.png'
import no from '../../assets/image/gq22.png'
import icon1 from '../../assets/image/zftb1.png'
import icon2 from '../../assets/image/zftb2.png'
import icon3 from '../../assets/image/zftb3.png'
import icon4 from '../../assets/image/zftb4.png'
import icon5 from '../../assets/image/zftb5.png'
import icon6 from '../../assets/image/zftb6.png'
import icon7 from '../../assets/image/zftb7.png'
import icon8 from '../../assets/image/zftb8.png'


export default {
 
    data(){
        return{
           tab_active:'1', 
           counrtyList:[
            {icon:ca,name:'CA'},{icon:gb,name:'GB'},{icon:eu,name:'EU'},{icon:mx,name:'MX'},{icon:cn,name:'CN'},{icon:jp,name:'JP'},{icon:au,name:'AU'},
            {icon:pl,name:'PL'},{icon:nl,name:'NL'},{icon:be,name:'BE'},{icon:dk,name:'DK'},{icon:ie,name:'IE'},{icon:cz,name:'CZ'},{icon:ro,name:'RO'},{icon:hu,name:'HU'},
            {icon:bg,name:'BG'},{icon:es,name:'ES'},{icon:pt,name:'PT'},{icon:fi,name:'FI'},{icon:se,name:'SE'},{icon:lv,name:'LV'},{icon:no,name:'NO'},
           ],
           zfList:[
            {icon:icon1},{icon:icon2},{icon:icon3},{icon:icon4},{icon:icon5},{icon:icon6},{icon:icon7},{icon:icon8},
           ],
          
           
        }
    },
     created () {
  
    
    },
    mounted(){
         
    },
    methods:{
      
    },
    beforeDestroy(){
       
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/db_bg2.png);
}
.grid_five{
    display: grid;
    grid-template-columns: 2fr 3fr 2fr;
   
    .item_group{
        .item_inner{
            .group_half{
               
                .half_text{
                    line-height: 2;
                }
            }
        }
        
    }
}
.half_title{
   font-size: 30px;
}
.half_text{
   font-size: 18px;
}
.ad_tab{
    font-size: 26px;
    padding:20px 0;
    transition: border 0.4s ease-in-out,color 0.4s ease-in-out;
    border-bottom:6px solid #E1E2E5;
    
}
.ad_tab_active{
     border-bottom:6px solid $theme_color3;
     color:$theme_color3;
}
.tab_container{
    background-image:url( ../../../public/bg/glbg.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    display: block;
}
.bg_3{
    background-image:url( ../../../public/bg/bg3.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
}
.custom-scroll {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;;
    
}
.scroll-content {
    display: flex;
    animation: gridScroll 30s linear infinite;

}
.rescroll-content {
    display: flex;
    animation: gridReScroll 30s linear infinite;
}
.country{
    padding:6px 10px;
    background: #262D4C;
    border-radius: 21px 21px 21px 21px;
    border: 1px solid #003CFF;
    align-items: baseline;
    opacity: 0.9;
    
    >img{
        width: auto;
       
    }
    margin:0 10px;
}
@keyframes gridScroll {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%);
    }
}
@keyframes gridReScroll {
    0% {
        transform: translateX(-50%);
    }
    100% {
        transform: translateX(0);
    }
}

.zf_tab{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin:0 14px;
}

.bg_4{
    background-image:url( ../../../public/bg/bg4.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
}
.bg_5{
    background-image:url( ../../../public/bg/bg5.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    height: calc(100% - 100px);
    width: 100%;
    margin-top:100px;
    margin-left:30px;
    position: absolute;
    z-index: 1;
}
.po_img{
    // position: absolute;
    position: relative;
    z-index: 2;
    width:100%;
    height: auto;
    // padding-bottom:100px;
}
@media screen and (max-width:991px){
    .grid_five{
      grid-template-columns:1fr;
      .item_group{
        padding:0;
      }
      .item_inner{
        // display: flex;
        .group_half{
           
            padding:20px 10px;
        }
      }
    }
    .ad_tab{
        font-size: 14px;
    }
    .grid_sp_item{
      padding:0;
    }
}
</style>